// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"771":"css/psg","8252":"css/app"}[chunkId] + ".css";
};